/* global axios */
// Team lead tools in Relay Voice, through Relay's voice manager API.
const base = accountId => `/api/v1/accounts/${accountId}/relay_voice_manager`;
const data = request => request.then(r => r.data);
const promptPath = (accountId, set, slot, voice) =>
  `${base(accountId)}/prompts/${set}/${encodeURIComponent(slot)}/${voice}`;

export const getBalance = accountId =>
  data(axios.get(`${base(accountId)}/balance`));

export const updateVoiceSettings = (accountId, settings) =>
  data(axios.patch(`${base(accountId)}/settings`, settings));

export const getPrompts = accountId =>
  data(axios.get(`${base(accountId)}/prompts`));

export const uploadPrompt = (accountId, { set, slot, voice, file }) => {
  const form = new FormData();
  form.append('file', file);
  return data(
    axios.post(`${promptPath(accountId, set, slot, voice)}/uploads`, form)
  );
};

export const generatePrompt = (accountId, { set, slot, voice, text }) =>
  data(axios.post(`${promptPath(accountId, set, slot, voice)}/tts`, { text }));

export const copyPrompt = (accountId, { set, slot, voice, versionUuid }) =>
  data(
    axios.post(`${promptPath(accountId, set, slot, voice)}/copies`, {
      version_uuid: versionUuid,
    })
  );

export const revertPrompt = (accountId, { set, slot, voice }) =>
  data(axios.post(`${promptPath(accountId, set, slot, voice)}/revert`));

export const activatePrompt = (accountId, versionUuid) =>
  data(
    axios.post(`${base(accountId)}/prompt_versions/${versionUuid}/activate`)
  );

export const promptAudio = (accountId, versionUuid) =>
  axios
    .get(`${base(accountId)}/prompt_versions/${versionUuid}/audio`, {
      responseType: 'blob',
    })
    .then(r => r.data);

export const setPromptVoice = (accountId, set, voice) =>
  data(axios.put(`${base(accountId)}/prompts/${set}/voice`, { voice }));

export const getIvrMenus = accountId =>
  data(axios.get(`${base(accountId)}/ivr_menus`));

export const getIvrMenu = (accountId, uuid) =>
  data(axios.get(`${base(accountId)}/ivr_menus/${uuid}`));

export const getIvrTargets = accountId =>
  data(axios.get(`${base(accountId)}/ivr_targets`));

export const previewIvrMenu = (accountId, menu) =>
  data(axios.post(`${base(accountId)}/ivr_menus/preview`, menu));

export const saveIvrMenu = (accountId, menu, uuid = null) =>
  data(
    uuid
      ? axios.put(`${base(accountId)}/ivr_menus/${uuid}`, menu)
      : axios.post(`${base(accountId)}/ivr_menus`, menu)
  );

export const getVoiceAudit = accountId =>
  data(axios.get(`${base(accountId)}/audit`));
